import { render } from "./ModalNewGroup.vue?vue&type=template&id=20df9e30"
import script from "./ModalNewGroup.vue?vue&type=script&lang=js"
export * from "./ModalNewGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__